module.exports = __webpack_public_path__ + "img/blockquote-left.e59b292d.svg";